import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface DollarSignIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const DollarSignIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: DollarSignIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M11.5928 11.0533H13.2012C14.6263 11.0533 15.3389 11.7184 15.3389 13.0485V16.4077C15.3389 17.7514 14.5992 18.4232 13.1197 18.4232H13.0994V20.0316H10.8803V18.4232C9.42799 18.4097 8.70185 17.7378 8.70185 16.4077V14.6365H11.0431V16.082C11.0431 16.2991 11.0838 16.4484 11.1653 16.5299C11.2467 16.5977 11.4028 16.6316 11.6335 16.6316H12.4072C12.6243 16.6316 12.7736 16.5977 12.8551 16.5299C12.9365 16.4484 12.9772 16.2991 12.9772 16.082V13.3335C12.9772 13.1163 12.9365 12.9738 12.8551 12.906C12.7736 12.8245 12.6243 12.7838 12.4072 12.7838H10.7581C9.36012 12.7838 8.66113 12.1052 8.66113 10.7479V7.59228C8.66113 6.24859 9.39406 5.57674 10.8599 5.57674H10.8803V3.96838H13.0994V5.57674C14.5652 5.57674 15.2981 6.24859 15.2981 7.59228V9.38386H12.9365V7.91802C12.9365 7.70086 12.8958 7.55835 12.8144 7.49048C12.7329 7.40905 12.5836 7.36833 12.3665 7.36833H11.5928C11.3621 7.36833 11.206 7.40905 11.1246 7.49048C11.0431 7.55835 11.0024 7.70086 11.0024 7.91802V10.5036C11.0024 10.7208 11.0431 10.8701 11.1246 10.9515C11.206 11.0194 11.3621 11.0533 11.5928 11.0533Z"
                fill={color}
            />
        </svg>
    )
}

export default DollarSignIcon
